module.exports = __webpack_public_path__ + "f769b3136ef7583475bb43a35dc99c50.svg";